















import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";
import { Component, Inject, Vue } from "vue-property-decorator";

@Component
export default class InvoicePaymentMethodMsg extends Vue {
  // Inject
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;
  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;

  public get $invoice() {
    return this.$invoiceProvider();
  }

  public get path() {
    return this.$invoice.hasPaymentMethod
      ? "_.selected_payment_method"
      : "_.no_payment_method_selected";
  }

  public get method() {
    return this.$invoice.invoice.payment_details
      ? this.$_.get(this.$invoice.invoice, "payment_details.name", "")
      : this.$_.get(this.$invoice.invoice, "gateway.name", "");
  }

  public get action() {
    return this.$invoice.hasPaymentMethod
      ? this.$t("_action.change")
      : this.$t("_action.select");
  }
}
